import { Box, Container } from '@mui/system'
import React from 'react'
import { Typography, Button,  Grid, IconButton } from '@mui/material';
import { Formik, Form, Field } from "formik";
import { TextField as MuiTextField } from 'formik-mui';
import Navbar from '../../components/Navbar';
import * as Yup from 'yup';
import { axiosPrivate } from '../../utils/apiUtils';
import { alertMsg } from '../../utils/basicUtils';
import { useNavigate } from 'react-router-dom';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import InputAdornment from '@mui/material/InputAdornment';

const Resend = () => {
    const navigate = useNavigate();
    return (
        <div>
            <Navbar></Navbar>
            <Container maxWidth="md" sx={{ minHeight:"calc(100vh - 75px)", display:"flex", alignItems:"center", justifyContent:"center" }}>
                <Grid container sx={{ justifyContent: "center", my:3 }}>
                    <Grid item xs={12} sm={10} md={8}>
                        <Box sx={{ boxShadow: "0 5px 15px rgb(63 81 181 / 12%)", borderRadius: "6px", padding: "30px 50px", }}>
                            <Box sx={{ mt: 2, textAlign: "center" }}>
                                <Typography sx={{ fontWeight: 500, fontSize: {xs:22, sm:25, md:30 } }}>Reset Email</Typography>
                            </Box>
                            <Formik
                                initialValues={{
                                    email: ''
                                }}
                                validationSchema={
                                    Yup.object({
                                        email: Yup.string().email()
                                            .required('Invalid email address')
                                            .required('Email is required')
                                    })
                                }
                                onSubmit={async (values, { setSubmitting, resetForm }) => {
                                    try {
                                        const response = await axiosPrivate.post("accounts/resend_activation_mail/", { email: values.email }
                                        )
                                        alertMsg(response.data.message, 'success')
                                        resetForm()
                                        setTimeout(() => {
                                            navigate('/accounts/signin')
                                        }, 5000)
                                    }
                                    catch (error) {
                                        console.error(error)
                                    }
                                    setSubmitting(false);
                                }}
                            >

                                {
                                    ({ isSubmitting, submitForm }) => {
                                        return (
                                            <Form>
                                                <Box>
                                                    <Box sx={{ mt: 4, position: "relative" }}>
                                                        <Field
                                                            component={MuiTextField}
                                                            name="email"
                                                            label="Email"
                                                            type="email"
                                                            fullWidth
                                                        />
                                                    </Box>
                                                </Box>
                                                <Box sx={{ mt: 4, textAlign: "center" }}>
                                                    <Button
                                                        size='large'
                                                        variant="outlined"
                                                        disabled={isSubmitting}
                                                        onClick={(e) => e.detail === 1 && submitForm() } 
                                                       
                                                    >Submit</Button>
                                                </Box>
                                            </Form>
                                        )
                                    }
                                }
                            </Formik>
                        </Box>
                    </Grid>
                </Grid>
            </Container>
        </div>
    )
}

export default Resend